import styles from './paymentForm.module.css'
import { FormGroup, Input, Label } from 'reactstrap'
import Paytm from '../../assets/paytm.png'
import classNames from 'classnames'
import React from "react";


function MobilePaymentForm({
    paymentMethod,
    handlePaymentMethod,
    branchPaymentData,
    logoBgColor = '#fff',
}) {
    const paymentOptions = branchPaymentData?.data || {}

    return (
        <>
            {Object.entries(paymentOptions).map(([key, value], index, arr) => (
                <React.Fragment key={key}>
                    <FormGroup className={styles.fitContent} check>
                        <Label check className="d-flex align-items-center">
                            <Input
                                type="radio"
                                name="paymentMethod"
                                value={key}
                                checked={paymentMethod === key}
                                onChange={handlePaymentMethod}
                                className={classNames({
                                    [styles.paytmmar]: key === 'paytm',
                                    [styles.othersmar]: key !== 'paytm',
                                })}
                                style={{ marginTop: '-2px' }}
                            />

                            {key === 'paytm' ? (
                                <img
                                    src={Paytm}
                                    width={80}
                                    alt="paytm-logo"
                                    className={styles.paymentMethodLogo}
                                    style={{ backgroundColor: logoBgColor }}
                                />
                            ) : (
                                <span
                                    className={`${styles.paymentMethodLogo} font-size-sm fw-lighter text-grey-llight pt-1`}
                                    style={{ backgroundColor: logoBgColor }}
                                >
                                    {value.label}
                                </span>
                            )}
                        </Label>
                    </FormGroup>

                    {index !== arr.length - 1 && (
                        <div className="border-bottom mt-3 mb-3"></div>
                    )}
                </React.Fragment>
            ))}
        </>
    )
}

export default MobilePaymentForm
